$(document).ready(() => {
    var isiOS = /iPhone/.test(navigator.userAgent);
    if ($(".search-box.home .smart-search .f-input").length > 0 && isiOS) {
        $(".search-box.home .smart-search .f-input").addClass("iPhone");
    }
    if ($(".main-header .search-box .smart-search.contracted .f-input").length > 0) { 
        $(".main-header .search-box .smart-search.contracted .f-input").addClass("iPhone");
    }
});